<template>
    <!-- 智能硬件基础设施 -->
    <div class="infrastructure">
        <div class="containers">
            <div class="HeaderTitle" ref="HeaderTitle">
                <h1 class="partH1">智能硬件基础设施</h1>
            </div>
            <ul class="infrastructure_ul">
                <li class="infrastructure_li li_bg1 infrastructure_li_hover" ref="libg1" @click="libg('key')">
                    <!-- <li>
                    <div class="infrastructure_li li_bg1 infrastructure_li_hover" ref="libg1" @mouseenter.stop="libg($event,'key')"> -->
                    <span class="li_info li_info_hover">
                        智能钥匙柜
                    </span>
                    <!-- </div> -->
                </li>

                <li class="infrastructure_li li_bg2" ref="libg2" @click="libg('oil')">
                    <span class="li_info">
                        智能油卡柜
                    </span>
                </li>

                <li class="infrastructure_li li_bg3" ref="libg3" @click="libg('wine')">
                    <span class="li_info">
                        酒精测试仪
                    </span>
                </li>
            </ul>
        </div>

        <div class="infrastructure_show_info">
            <div>
                <div class="show_info_main containers" v-show="tabCheck==='智能钥匙柜'">
                    <div class="show_info_left" ref="keyFont">
                        <h3>解决的问题</h3>
                        <div>
                            <p>企业钥匙管理依赖人工，领还过程费事费力</p>
                            <img src="../../assets/imgs/dedeauto/solve_problem_key.png">
                        </div>
                    </div>
                    <div class="show_info_right" ref="keyMain">
                        <h3>主要特点</h3>
                        <ul  ref="keyList">
                            <li>
                                <img src="../../assets/imgs/dedeauto/icon_intelligent_identification.png">
                                <p>智能识别</p>
                            </li>
                            <li>
                                <img src="../../assets/imgs/dedeauto/icon_intelligence_communication.png">
                                <p>智能通信</p>
                            </li>
                            <li>
                                <img src="../../assets/imgs/dedeauto/icon_intelligent_control.png">
                                <p>智能控制</p>
                            </li>
                            <li>
                                <img src="../../assets/imgs/dedeauto/icon_intelligent_power.png">
                                <p>智能电源</p>
                            </li>
                            <li>
                                <img src="../../assets/imgs/dedeauto/icon_intelligent_chip.png">
                                <p>智能芯片</p>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="show_info_main containers" v-show="tabCheck==='智能油卡柜'">
                    <div class="show_info_left" ref="keyFont2">
                        <h3>解决的问题</h3>
                        <div>
                            <p>加油卡人工保管方式无法确保油卡使用状态</p>
                            <img src="../../assets/imgs/dedeauto/Oil_tank_card.png">
                        </div>
                    </div>
                    <div class="show_info_right" ref="keyMain2">
                        <h3>主要特点</h3>
                        <ul>
                            <li>
                                <img src="../../assets/imgs/dedeauto/icon_card_status.png">
                                <p>卡使用状态</p>
                            </li>
                            <li>
                                <img src="../../assets/imgs/dedeauto/icon_oil_record.png">
                                <p>加油记录</p>
                            </li>
                            <li>
                                <img src="../../assets/imgs/dedeauto/icon_oil_balance.png">
                                <p>油卡余额</p>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="show_info_main containers" v-show="tabCheck==='酒精测试仪'">
                    <div class="show_info_left" ref="keyFont3">
                        <h3>解决的问题</h3>
                        <div>
                            <p>驾驶员每日合规上路</p>
                            <img src="../../assets/imgs/dedeauto/drunk_driving_check.png">
                        </div>
                    </div>
                    <div class="show_info_right" ref="keyMain3">
                        <h3>主要特点</h3>
                        <ul>
                            <li>
                                <img src="../../assets/imgs/dedeauto/icon_intelligent_identification.png">
                                <p>智能识别</p>
                            </li>
                            <li>
                                <img src="../../assets/imgs/dedeauto/icon_alcohol report.png">
                                <p>酒精检测报告</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import animationUtils from "@/utils/animationUtils.js";
    import animationIndex from "@/utils/animationIndex.js";

    export default {
        data() {
            return {
                // tab切换
                tabCheck: '智能钥匙柜',
                // liDom: [],
            }
        },
        mounted() {
            // let liDomArr = this.$refs.keyList.children;
            // for (let i = 0; i < liDomArr.length; i++) {
            //     this.liDom.push(liDomArr[i].classList)
            // }
            // console.log(this.liDom);

            // this.keyFeature.forEach((item, index) => { //获取需要给加动画的各个li的ref节点
            //     this.liDom.push(this.$refs[`li${index}`][0].classList);
            // })
            window.addEventListener("scroll", this.menu);
        },
        beforeDestroy() { //在加载时添加了scroll监听，如果不销毁，到下一个页面时，没有主动销毁，会报错'offsetTop' of undefined。因此，需要在页面跳转前销毁此监听
            window.removeEventListener("scroll", this.menu)
        },

        methods: {
            libg(val) {
                // 获取需要操作的盒子
                let libg1 = this.$refs.libg1;
                let libg2 = this.$refs.libg2;
                let libg3 = this.$refs.libg3;
                if (val === 'key') {
                    this.tabCheck = '智能钥匙柜';
                    // 其他盒子样式移除
                    libg2.classList = 'infrastructure_li li_bg2';
                    libg2.children[0].classList = libg3.children[0].classList = 'li_info';
                    libg3.classList = 'infrastructure_li li_bg3';
                    // 本盒子激活样式添加
                    libg1.children[0].classList = 'li_info li_info_hover';
                    libg1.classList = 'infrastructure_li li_bg1 infrastructure_li_hover';
                } else if (val === 'oil') {
                    this.tabCheck = '智能油卡柜';
                    // 其他盒子样式移除
                    libg1.classList = 'infrastructure_li li_bg1';
                    libg1.children[0].classList = libg3.children[0].classList = 'li_info';
                    libg3.classList = 'infrastructure_li li_bg3';
                    // 本盒子激活样式添加
                    libg2.children[0].classList = 'li_info li_info_hover';
                    libg2.classList = 'infrastructure_li li_bg2 infrastructure_li_hover';
                } else if (val === 'wine') {
                    this.tabCheck = '酒精测试仪';
                    // 其他盒子样式移除
                    libg1.classList = 'infrastructure_li li_bg1';
                    libg1.children[0].classList = libg2.children[0].classList = 'li_info';
                    libg2.classList = 'infrastructure_li li_bg2';
                    // 本盒子激活样式添加
                    libg3.children[0].classList = 'li_info li_info_hover';
                    libg3.classList = 'infrastructure_li li_bg3 infrastructure_li_hover';
                }
            },
            menu() {
                // 标题动画
                let HeaderTitleOffsetTop = this.$refs.HeaderTitle.offsetTop; //获取当前元素距离文档顶部的高度
                let HeaderTitle = this.$refs.HeaderTitle.classList;
                animationUtils.animations(HeaderTitleOffsetTop, HeaderTitle, "activeTitle");
                //右侧列表动画
                let keyListOffsetTop = this.$refs.keyList.offsetTop; //获取当前元素距离文档顶部的高度
                /**
                 * animationIndex第一个参数为需要动画的dom元素的高度，
                 * 第二个参数为li的每个单元的dom样式类数组
                 * 第三个参数为动画样式类名称
                 * 第四个参数为每个li动画执行间隔时间
                 * */
                // animationIndex.animationIndex(keyListOffsetTop, this.liDom, "fade--in", 600);

                /**
                 * animations方法的第一个参数是需要动画的dom元素的高度，
                 * 第二个参数是需要加动画的dom元素的样式列表数组，
                 * 第三参数是动画类型（样式类名）activeTitle：文字动画，activeShade图片出现前的遮罩动画，activeTitle图片动画
                 */
                //左侧文字标题动画
                let keyFontOffsetTop = this.$refs.keyFont.offsetTop; //获取当前元素距离文档顶部的高度
                let keyFont = this.$refs.keyFont.classList;
                let keyMain = this.$refs.keyMain.classList;
                animationUtils.animations(keyFontOffsetTop, keyFont, "activeTitle");
                animationUtils.animations(keyFontOffsetTop, keyMain, "activeTitle");
                let keyFont2 = this.$refs.keyFont2.classList;
                let keyMain2 = this.$refs.keyMain2.classList;
                animationUtils.animations(keyFontOffsetTop, keyFont2, "activeTitle");
                animationUtils.animations(keyFontOffsetTop, keyMain2, "activeTitle");
                let keyFont3 = this.$refs.keyFont3.classList;
                let keyMain3 = this.$refs.keyMain3.classList;
                animationUtils.animations(keyFontOffsetTop, keyFont3, "activeTitle");
                animationUtils.animations(keyFontOffsetTop, keyMain3, "activeTitle");

            }
        }
    };
</script>

<style scoped>
    .infrastructure .partH1 {
        opacity: 1;
    }
    .HeaderTitle{
        opacity: 0;
    }
</style>